export class OpenRightMenu {
    constructor(optionalOptions = {}) {
        this._menu = document.querySelector('.open-right-menu');

        if (!this._menu) {
            this.destructor();
            return true;
        }

        let documentWrap = document.getElementById('wrap-wrap');
        let menu = document.getElementById('user-right--menu');

        this._menu.addEventListener("click", (event) => {
            if (documentWrap.classList.contains('user-show-menu')) {
                menu.classList.remove('show')
                documentWrap.classList.remove('user-show-menu')
            } else {
                documentWrap.classList.add('user-show-menu')
                menu.classList.add('show')
            }
        })

        if (documentWrap.classList.contains('user-show-menu')) {
            document.querySelector('.user-show-menu--overlay').addEventListener("click", (event) => {
                menu.classList.remove('show')
                documentWrap.classList.remove('user-show-menu')
            });
        }
    }

    destructor() {
        this._menu = null;
    }
}

export default new OpenRightMenu();